const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Некорректный ввод min и max.',
    invalid_options: 'Некорректные параметры поля.',
    invalid_regex_format: 'Неверный формат регулярного выражения.',
    invalid_address_parts: 'Некорректные части адреса.',
    invalid_fullname_parts: 'Некорректные части полного имени.',
    name_exists: 'Поле с таким именем уже существует.',
    conflicted_sie_order: 'Конфликт значения порядка поля для опыта входа.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
